import { SelectOption } from '@/components'

export const UNKNOWN_BAT_SPECIE_OPTION_VALUE = 'Onbekend'
export const OTHER_SPECIE_OPTION_VALUE = 'Anders, uitleg andere soort'

export const BAT_COMMON_DWARF_BAT = 'Gewone dwergvleermuis'
export const BAT_ROUGH_EARED = 'Ruige dwergvleermuis'

export const OPTIONAL_RECORDING_NUMBER_SPECIES = [
  BAT_COMMON_DWARF_BAT,
  BAT_ROUGH_EARED,
]

export const BATS_SPECIE_OPTIONS: SelectOption[] = [
  {
    name: 'Baardvleermuis',
    value: 'Baardvleermuis',
  },
  {
    name: "Bechstein's vleermuis",
    value: "Bechstein's vleermuis",
  },
  {
    name: 'Bosvleermuis',
    value: 'Bosvleermuis',
  },
  {
    name: "Brandt's vleermuis",
    value: "Brandt's vleermuis",
  },
  {
    name: 'Franjestaart',
    value: 'Franjestaart',
  },
  {
    name: BAT_COMMON_DWARF_BAT,
    value: BAT_COMMON_DWARF_BAT,
  },
  {
    name: 'Gewone grootoorvleermuis',
    value: 'Gewone grootoorvleermuis',
  },
  {
    name: 'Grijze grootoorvleermuis',
    value: 'Grijze grootoorvleermuis',
  },
  {
    name: 'Ingekorven vleermuis',
    value: 'Ingekorven vleermuis',
  },
  {
    name: 'Kleine dwergvleermuis',
    value: 'Kleine dwergvleermuis',
  },
  {
    name: 'Laatvlieger',
    value: 'Laatvlieger',
  },
  {
    name: 'Meervleermuis',
    value: 'Meervleermuis',
  },
  {
    name: 'Mopsvleermuis',
    value: 'Mopsvleermuis',
  },
  {
    name: 'Rosse vleermuis',
    value: 'Rosse vleermuis',
  },
  {
    name: BAT_ROUGH_EARED,
    value: BAT_ROUGH_EARED,
  },
  {
    name: 'Tweekleurige vleermuis',
    value: 'Tweekleurige vleermuis',
  },
  {
    name: 'Vale vleermuis',
    value: 'Vale vleermuis',
  },
  {
    name: 'Myotis specie',
    value: 'Myotis specie',
  },
  {
    name: 'Watervleermuis',
    value: 'Watervleermuis',
  },
  {
    name: UNKNOWN_BAT_SPECIE_OPTION_VALUE,
    value: UNKNOWN_BAT_SPECIE_OPTION_VALUE,
  },
  {
    name: OTHER_SPECIE_OPTION_VALUE,
    value: OTHER_SPECIE_OPTION_VALUE,
  },
]

export const HOUSE_SPARROW_SPECIE = 'Huismus'

export const BIRDS_BREEDING_SPECIE_OPTIONS: SelectOption[] = [
  {
    name: 'Boerenzwaluw',
    value: 'Boerenzwaluw',
  },
  {
    name: 'Boomklever',
    value: 'Boomklever',
  },
  {
    name: 'Boomkruiper',
    value: 'Boomkruiper',
  },
  {
    name: 'Bosuil',
    value: 'Bosuil',
  },
  {
    name: 'Ekster',
    value: 'Ekster',
  },
  {
    name: 'Gierzwaluw',
    value: 'Gierzwaluw',
  },
  {
    name: 'Houtduif',
    value: 'Houtduif',
  },
  {
    name: HOUSE_SPARROW_SPECIE,
    value: HOUSE_SPARROW_SPECIE,
  },
  {
    name: 'Huiszwaluw',
    value: 'Huiszwaluw',
  },
  {
    name: 'Kauw',
    value: 'Kauw',
  },
  {
    name: 'Kerkuil',
    value: 'Kerkuil',
  },
  {
    name: 'Koolmees',
    value: 'Koolmees',
  },
  {
    name: 'Ooievaar',
    value: 'Ooievaar',
  },
  {
    name: 'Pimpelmees',
    value: 'Pimpelmees',
  },
  {
    name: 'Roek',
    value: 'Roek',
  },
  {
    name: 'Spreeuw',
    value: 'Spreeuw',
  },
  {
    name: 'Stadsduif',
    value: 'Stadsduif',
  },
  {
    name: 'Steenuil',
    value: 'Steenuil',
  },
  {
    name: 'Zwarte roodstraat',
    value: 'Zwarte roodstraat',
  },
  {
    name: 'Duif spec.',
    value: 'Duif spec.',
  },
  {
    name: 'Torenvalk',
    value: 'Torenvalk',
  },
  {
    name: 'Turkse tortel',
    value: 'Turkse tortel',
  },
  {
    name: 'Kleine mantelmeeuw',
    value: 'Kleine mantelmeeuw',
  },
  {
    name: 'Meeuw spec.',
    value: 'Meeuw spec.',
  },
  {
    name: 'Scholekster',
    value: 'Scholekster',
  },
  {
    name: 'Visdief',
    value: 'Visdief',
  },
  {
    name: 'Zilvermeeuw',
    value: 'Zilvermeeuw',
  },
  {
    name: 'Boomvalk',
    value: 'Boomvalk',
  },
  {
    name: 'Buizerd',
    value: 'Buizerd',
  },
  {
    name: 'Grote gele kwikstaart',
    value: 'Grote gele kwikstaart',
  },
  {
    name: 'Havik',
    value: 'Havik',
  },
  {
    name: 'Heggemus',
    value: 'Heggemus',
  },
  {
    name: 'Oehoe',
    value: 'Oehoe',
  },
  {
    name: 'Ransuil',
    value: 'Ransuil',
  },
  {
    name: 'Roofvogel spec.',
    value: 'Roofvogel spec.',
  },
  {
    name: 'Slechtvalk',
    value: 'Slechtvalk',
  },
  {
    name: 'Sperwer',
    value: 'Sperwer',
  },
  {
    name: 'Zwarte kraai',
    value: 'Zwarte kraai',
  },
  {
    name: OTHER_SPECIE_OPTION_VALUE,
    value: OTHER_SPECIE_OPTION_VALUE,
  },
]

export const MAMMALS_SPECIE_OPTIONS: SelectOption[] = [
  {
    name: 'Boommarter',
    value: 'Boommarter',
  },
  {
    name: 'Bunzing',
    value: 'Bunzing',
  },
  {
    name: 'Bever',
    value: 'Bever',
  },
  {
    name: 'Eikelmuis',
    value: 'Eikelmuis',
  },
  {
    name: 'Konijn',
    value: 'Konijn',
  },
  {
    name: 'Korenwolf',
    value: 'Korenwolf',
  },
  {
    name: 'Mol',
    value: 'Mol',
  },
  {
    name: 'Muis spec.',
    value: 'Muis spec.',
  },
  {
    name: 'Rat',
    value: 'Rat',
  },
  {
    name: 'Waterspitsmuis',
    value: 'Waterspitsmuis',
  },
  {
    name: 'Das',
    value: 'Das',
  },
  {
    name: 'Eekhoorn',
    value: 'Eekhoorn',
  },
  {
    name: 'Egel',
    value: 'Egel',
  },
  {
    name: 'Haas',
    value: 'Haas',
  },
  {
    name: 'Hermelijn',
    value: 'Hermelijn',
  },
  {
    name: 'Steenmarter',
    value: 'Steenmarter',
  },
  {
    name: 'Vos',
    value: 'Vos',
  },
  {
    name: 'Wezel',
    value: 'Wezel',
  },
  {
    name: 'Wolf',
    value: 'Wolf',
  },
  {
    name: OTHER_SPECIE_OPTION_VALUE,
    value: OTHER_SPECIE_OPTION_VALUE,
  },
]

export const AMPHIBIANS_SPECIE_OPTIONS: SelectOption[] = [
  {
    name: 'Alpenwatersalamander',
    value: 'Alpenwatersalamander',
  },
  {
    name: 'Bastaardkikker',
    value: 'Bastaardkikker',
  },
  {
    name: 'Boomkikker',
    value: 'Boomkikker',
  },
  {
    name: 'Bruine kikker',
    value: 'Bruine kikker',
  },
  {
    name: 'Geelbuikvuurpad',
    value: 'Geelbuikvuurpad',
  },
  {
    name: 'Gewone pad',
    value: 'Gewone pad',
  },
  {
    name: 'Groene kikker (complex)',
    value: 'Groene kikker (complex)',
  },
  {
    name: 'Heikikker',
    value: 'Heikikker',
  },
  {
    name: 'Kamsalamander',
    value: 'Kamsalamander',
  },
  {
    name: 'Kikker spec.',
    value: 'Kikker spec.',
  },
  {
    name: 'Kleine watersalamander',
    value: 'Kleine watersalamander',
  },
  {
    name: 'Knoflookpad',
    value: 'Knoflookpad',
  },
  {
    name: 'Meerkikker',
    value: 'Meerkikker',
  },
  {
    name: 'Pad spec.',
    value: 'Pad spec',
  },
  {
    name: 'Poelkikker',
    value: 'Poelkikker',
  },
  {
    name: 'Rugstreeppad',
    value: 'Rugstreeppad',
  },
  {
    name: 'Salamander spec.',
    value: 'Salamander spec.',
  },
  {
    name: 'Vinpootsalamander',
    value: 'Vinpootsalamander',
  },
  {
    name: 'Vroedmeesterpad',
    value: 'Vroedmeesterpad',
  },
  {
    name: 'Vuursalamander',
    value: 'Vuursalamander',
  },
  {
    name: OTHER_SPECIE_OPTION_VALUE,
    value: OTHER_SPECIE_OPTION_VALUE,
  },
]

export const WIND_DIRECTION_OPTIONS: SelectOption[] = [
  {
    name: 'N',
    value: 'N',
  },
  {
    name: 'NO',
    value: 'NO',
  },
  {
    name: 'O',
    value: 'O',
  },
  {
    name: 'ZO',
    value: 'ZO',
  },
  {
    name: 'Z',
    value: 'Z',
  },
  {
    name: 'ZW',
    value: 'ZW',
  },
  {
    name: 'W',
    value: 'W',
  },
  {
    name: 'NW',
    value: 'NW',
  },
]

export const BATS_BIRDS_COUNTING_METHOD_OPTIONS: SelectOption[] = [
  {
    name: 'Exact',
    value: 'Exact',
  },
  {
    name: 'Schatting',
    value: 'Schatting',
  },
]

export const AMPHIBIANS_EDNA = 'eDNA'
export const AMPHIBIANS_CREATE = 'Scheppen'

export const AMPHIBIANS_SKIP_BEHAVIOUR = [AMPHIBIANS_EDNA, AMPHIBIANS_CREATE]

export const AMPHIBIANS_COUNTING_METHOD_OPTIONS: SelectOption[] = [
  {
    name: 'Exact',
    value: 'Exact',
  },
  {
    name: 'Schatting',
    value: 'Schatting',
  },
  {
    name: 'Luisteren',
    value: 'Luisteren',
  },
  {
    name: AMPHIBIANS_CREATE,
    value: AMPHIBIANS_CREATE,
  },
  {
    name: AMPHIBIANS_EDNA,
    value: AMPHIBIANS_EDNA,
  },
]
export const INSECTS_COUNTING_METHOD_OPTIONS: SelectOption[] = [
  {
    name: 'Exact',
    value: 'Exact',
  },
  {
    name: 'Luisteren',
    value: 'Luisteren',
  },
  {
    name: 'Schatting',
    value: 'Schatting',
  },
]

const BATS_GEDRAG_FLYING_IN_FROM_RESIDENCE_TREE =
  'Invliegen verblijfplaats boom'
const BATS_GEDRAG_FLYING_IN_FROM_RESIDENCE_BUILDING =
  'Invliegen verblijfplaats gebouw'
const BATS_GEDRAG_FLYING_OUT_FROM_RESIDENCE_TREE =
  'Uitvliegen verblijfplaats boom'
const BATS_GEDRAG_FLYING_OUT_FROM_RESIDENCE_BUILDING =
  'Uitvliegen verblijfplaats gebouw'
const BATS_GEDRAG_TOUCHING_TREE = 'Aantikken boom'
const BATS_GEDRAG_TOUCHING_BUILDING = 'Aantikken gebouw'
const BATS_GEDRAG_SWARMS = 'Zwermen'

export const BATS_BEHAVIOUR_REQUIRE_PLACE_FOUND = [
  BATS_GEDRAG_FLYING_IN_FROM_RESIDENCE_TREE,
  BATS_GEDRAG_FLYING_IN_FROM_RESIDENCE_BUILDING,
  BATS_GEDRAG_FLYING_OUT_FROM_RESIDENCE_TREE,
  BATS_GEDRAG_FLYING_OUT_FROM_RESIDENCE_BUILDING,
  BATS_GEDRAG_TOUCHING_TREE,
  BATS_GEDRAG_TOUCHING_BUILDING,
  BATS_GEDRAG_SWARMS,
]

export const BATS_GEDRAG_BALTSEN = 'Baltsen'

export const OTHER_GEDRAG_OPTION_VALUE = 'Anders, uitleg ander gedrag'
export const BATS_GEDRAG_OPTIONS: SelectOption[] = [
  {
    name: BATS_GEDRAG_TOUCHING_TREE,
    value: BATS_GEDRAG_TOUCHING_TREE,
  },
  {
    name: BATS_GEDRAG_TOUCHING_BUILDING,
    value: BATS_GEDRAG_TOUCHING_BUILDING,
  },
  {
    name: BATS_GEDRAG_BALTSEN,
    value: BATS_GEDRAG_BALTSEN,
  },
  {
    name: 'Baltsen vanuit vaste plaats',
    value: 'Baltsen vanuit vaste plaats',
  },
  {
    name: 'Foerageren',
    value: 'Foerageren',
  },
  {
    name: BATS_GEDRAG_FLYING_IN_FROM_RESIDENCE_TREE,
    value: BATS_GEDRAG_FLYING_IN_FROM_RESIDENCE_TREE,
  },
  {
    name: BATS_GEDRAG_FLYING_IN_FROM_RESIDENCE_BUILDING,
    value: BATS_GEDRAG_FLYING_IN_FROM_RESIDENCE_BUILDING,
  },
  {
    name: 'Overvliegen',
    value: 'Overvliegen',
  },
  {
    name: 'Sociale roep',
    value: 'Sociale roep',
  },
  {
    name: BATS_GEDRAG_FLYING_OUT_FROM_RESIDENCE_TREE,
    value: BATS_GEDRAG_FLYING_OUT_FROM_RESIDENCE_TREE,
  },
  {
    name: BATS_GEDRAG_FLYING_OUT_FROM_RESIDENCE_BUILDING,
    value: BATS_GEDRAG_FLYING_OUT_FROM_RESIDENCE_BUILDING,
  },
  {
    name: BATS_GEDRAG_SWARMS,
    value: BATS_GEDRAG_SWARMS,
  },
  {
    name: OTHER_GEDRAG_OPTION_VALUE,
    value: OTHER_GEDRAG_OPTION_VALUE,
  },
]
export const DIRECTION_BIRD_GEDRAG_OPTION_VALUE = 'Overvliegend, zie richting'

export const BIRDS_BEHAVIOUR_NEST_WITH_YOUNG = 'Nest met jongen'
export const BIRDS_BEHAVIOUR_NEST = 'Nest'
export const BIRDS_BEHAVIOUR_NEST_INDICATING = 'Nestindicerend gedrag'
export const BIRDS_BEHAVIOUR_BALLSEND = 'Baltsend'

export const BIRDS_BEHAVIOUR_REQUIRE_PHOTOS = [
  BIRDS_BEHAVIOUR_NEST_WITH_YOUNG,
  BIRDS_BEHAVIOUR_NEST,
]

export const ALL_BIRDS_PLACE_FOUND_BEHAVIOUR = [
  BIRDS_BEHAVIOUR_NEST,
  BIRDS_BEHAVIOUR_NEST_WITH_YOUNG,
  BIRDS_BEHAVIOUR_NEST_INDICATING,
]

export const HOUSE_SPARROW_PLACE_FOUND_BEHAVIOUR = [
  ...ALL_BIRDS_PLACE_FOUND_BEHAVIOUR,
  BIRDS_BEHAVIOUR_BALLSEND,
]

export const BIRDS_GEDRAG_OPTIONS: SelectOption[] = [
  {
    name: 'Aanwezig',
    value: 'Aanwezig',
  },
  {
    name: 'Overleden',
    value: 'Overleden',
  },
  {
    name: 'Foerageren/jagend',
    value: 'Foerageren/jagend',
  },
  {
    name: BIRDS_BEHAVIOUR_NEST,
    value: BIRDS_BEHAVIOUR_NEST,
  },
  {
    name: BIRDS_BEHAVIOUR_NEST_WITH_YOUNG,
    value: BIRDS_BEHAVIOUR_NEST_WITH_YOUNG,
  },
  {
    name: BIRDS_BEHAVIOUR_NEST_INDICATING,
    value: BIRDS_BEHAVIOUR_NEST_INDICATING,
  },
  {
    name: DIRECTION_BIRD_GEDRAG_OPTION_VALUE,
    value: DIRECTION_BIRD_GEDRAG_OPTION_VALUE,
  },
  {
    name: 'Paar/koppel',
    value: 'Paar/koppel',
  },
  {
    name: 'Nest, vernietigd',
    value: 'Nest, vernietigd',
  },
  {
    name: 'Parend',
    value: 'Parend',
  },
  {
    name: 'Roepend/zingend',
    value: 'Roepend/zingend',
  },
  {
    name: OTHER_GEDRAG_OPTION_VALUE,
    value: OTHER_GEDRAG_OPTION_VALUE,
  },
]

export const MAMMALS_GEDRAG_OPTIONS: SelectOption[] = [
  {
    name: 'Aanwezig',
    value: 'Aanwezig',
  },
  {
    name: 'Dood',
    value: 'Dood',
  },
  {
    name: 'Foerageren',
    value: 'Foerageren',
  },
  {
    name: 'Nabij (nest, burcht)',
    value: 'Nabij (nest, burcht)',
  },
  {
    name: 'Nest/burcht',
    value: 'Nest/burcht',
  },
  {
    name: 'Nest/burcht met jongen',
    value: 'Nest/burcht met jongen',
  },
  {
    name: 'Sociaal gedrag',
    value: 'Sociaal gedrag',
  },
  {
    name: 'Hol',
    value: 'Hol',
  },
  {
    name: 'Graafsporen',
    value: 'Graafsporen',
  },
  {
    name: 'Uitwerpselen',
    value: 'Uitwerpselen',
  },
  {
    name: 'Sporen',
    value: 'Sporen',
  },
  {
    name: 'Territorium gedrag',
    value: 'Territorium gedrag',
  },
  {
    name: 'Zonnend',
    value: 'Zonnend',
  },
  {
    name: OTHER_GEDRAG_OPTION_VALUE,
    value: OTHER_GEDRAG_OPTION_VALUE,
  },
]

export const AMPHIBIANS_GEDRAG_OPTIONS: SelectOption[] = [
  {
    name: 'Aanwezig',
    value: 'Aanwezig',
  },
  {
    name: 'Foerageren',
    value: 'Foerageren',
  },
  {
    name: 'Overwinterend',
    value: 'Overwinterend',
  },
  {
    name: 'Parend',
    value: 'Parend',
  },
  {
    name: 'Roepend',
    value: 'Roepend',
  },
  {
    name: 'Zonnend',
    value: 'Zonnend',
  },
  {
    name: OTHER_GEDRAG_OPTION_VALUE,
    value: OTHER_GEDRAG_OPTION_VALUE,
  },
]
export const INSECTS_GEDRAG_OPTIONS: SelectOption[] = [
  {
    name: 'Foerageren',
    value: 'Foerageren',
  },
  {
    name: 'Geparasiteerd',
    value: 'Geparasiteerd',
  },
  {
    name: 'Pop',
    value: 'Pop',
  },
  {
    name: 'Eieren',
    value: 'Eieren',
  },
  {
    name: 'Dood',
    value: 'Dood',
  },
  {
    name: 'Op waardplant',
    value: 'Op waardplant',
  },
  {
    name: 'Overwinterend',
    value: 'Overwinterend',
  },
  {
    name: 'Parend',
    value: 'Parend',
  },
  {
    name: 'Chirpend',
    value: 'Chirpend',
  },
  {
    name: 'Uitsluipend',
    value: 'Uitsluipend',
  },
  {
    name: 'Zonnend',
    value: 'Zonnend',
  },
  {
    name: OTHER_GEDRAG_OPTION_VALUE,
    value: OTHER_GEDRAG_OPTION_VALUE,
  },
]

export const PLACE_TYPE_MATERNITY_HOME = 'Kraamverblijfplaats'

export const PLACE_TYPE_OPTIONS: SelectOption[] = [
  {
    name: 'Baltsverblijfplaats',
    value: 'Baltsverblijfplaats',
  },
  {
    name: PLACE_TYPE_MATERNITY_HOME,
    value: PLACE_TYPE_MATERNITY_HOME,
  },
  {
    name: 'Massawinter zwerm',
    value: 'Massawinter zwerm',
  },
  {
    name: 'Zomerverblijfplaats',
    value: 'Zomerverblijfplaats',
  },
  {
    name: 'Winterverblijf',
    value: 'Winterverblijf',
  },
]

export const PLACE_FOUND_OPTION_VALUE = 'Gevonden'
export const PLACE_NOT_FOUND_OPTION_VALUE = 'Geen verblijfplaats'
export const PLACE_FOUND_OPTIONS: SelectOption[] = [
  {
    name: PLACE_FOUND_OPTION_VALUE,
    value: PLACE_FOUND_OPTION_VALUE,
  },
  {
    name: PLACE_NOT_FOUND_OPTION_VALUE,
    value: PLACE_NOT_FOUND_OPTION_VALUE,
  },
  {
    name: 'Eerder gevonden',
    value: 'Eerder gevonden',
  },
]

export const REPTILES_COUNTING_METHOD_OPTIONS: SelectOption[] = [
  {
    name: 'Exact',
    value: 'Exact',
  },
  {
    name: 'Schatting',
    value: 'Schatting',
  },
]

export const COURTSHIP_TERRITORY_SPECIE_OPTIONS: SelectOption[] = [
  {
    name: BAT_COMMON_DWARF_BAT,
    value: BAT_COMMON_DWARF_BAT,
  },
  {
    name: BAT_ROUGH_EARED,
    value: BAT_ROUGH_EARED,
  },
]

export const REPTILES_SPECIE_OPTIONS: SelectOption[] = [
  {
    value: 'Adder',
    name: 'Adder',
  },
  {
    value: 'Gladde slang',
    name: 'Gladde slang',
  },
  {
    value: 'Hazelworm',
    name: 'Hazelworm',
  },
  {
    value: 'Levendbarende hagedis',
    name: 'Levendbarende hagedis',
  },
  {
    value: 'Muurhagedis',
    name: 'Muurhagedis',
  },
  {
    value: 'Ringslang',
    name: 'Ringslang',
  },
  {
    value: 'Zandhagedis',
    name: 'Zandhagedis',
  },
  {
    value: OTHER_SPECIE_OPTION_VALUE,
    name: OTHER_SPECIE_OPTION_VALUE,
  },
]

export const REPTILES_BEHAVIOUR_OPTIONS: SelectOption[] = [
  {
    value: 'Aanwezig',
    name: 'Aanwezig',
  },
  {
    value: 'Foerageren',
    name: 'Foerageren',
  },
  {
    value: 'Overwinterend',
    name: 'Overwinterend',
  },
  {
    value: 'Parend',
    name: 'Parend',
  },
  {
    value: 'Zonnend',
    name: 'Zonnend',
  },
  {
    value: OTHER_GEDRAG_OPTION_VALUE,
    name: OTHER_GEDRAG_OPTION_VALUE,
  },
]

export const FISH_SPECIE_OPTIONS: SelectOption[] = [
  {
    value: 'Beekprik',
    name: 'Beekprik',
  },
  {
    value: 'Bittervoorn',
    name: 'Bittervoorn',
  },
  {
    value: 'Driehoornige stekelbaars',
    name: 'Driehoornige stekelbaars',
  },
  {
    value: 'Grote modderkruiper',
    name: 'Grote modderkruiper',
  },
  {
    value: 'Kleine modderkruiper',
    name: 'Kleine modderkruiper',
  },
  {
    value: 'Rivierprik',
    name: 'Rivierprik',
  },
  {
    value: OTHER_SPECIE_OPTION_VALUE,
    name: OTHER_SPECIE_OPTION_VALUE,
  },
]

export const FISH_COUNTING_METHOD_OPTIONS: SelectOption[] = [
  {
    name: 'Exact',
    value: 'Exact',
  },
  {
    name: 'Schatting',
    value: 'Schatting',
  },
]

export const OTHER_COUNTING_OPTION_OPTION_VALUE =
  'Anders, uitleg andere telmethode'
export const SAMPLE_POINT_COUNTING_METHOD_OPTIONS: SelectOption[] = [
  {
    value: 'Scheppen',
    name: 'Scheppen',
  },
  {
    value: 'eDNA',
    name: 'eDNA',
  },
  {
    value: 'Malaise',
    name: 'Malaise',
  },
  {
    value: 'Stilstaande batlogger',
    name: 'Stilstaande batlogger',
  },
  {
    value: 'Battracker',
    name: 'Battracker',
  },
  {
    value: 'Amfibieplaat',
    name: 'Amfibieplaat',
  },
  {
    value: 'Cameraval - Struikrover',
    name: 'Cameraval - Struikrover',
  },
  {
    value: OTHER_COUNTING_OPTION_OPTION_VALUE,
    name: OTHER_COUNTING_OPTION_OPTION_VALUE,
  },
]

export const PLANT_STAGE_OPTIONS: SelectOption[] = [
  {
    value: 'Kiemplant',
    name: 'Kiemplant',
  },
  {
    value: 'Zaailing',
    name: 'Zaailing',
  },
  {
    value: 'Groeifase',
    name: 'Groeifase',
  },
  {
    value: 'Bloeifase',
    name: 'Bloeifase',
  },
  {
    value: 'Vruchtenfase',
    name: 'Vruchtenfase',
  },
]

export const PHYSICAL_INSPECTION_BAT_SPECIE_VALUE = 'Vleermuis'
export const PHYSICAL_INSPECTION_SPECIE_OPTIONS: SelectOption[] = [
  {
    value: 'Huismus',
    name: 'Huismus',
  },
  {
    value: 'Gierzwaluw',
    name: 'Gierzwaluw',
  },
  {
    value: PHYSICAL_INSPECTION_BAT_SPECIE_VALUE,
    name: PHYSICAL_INSPECTION_BAT_SPECIE_VALUE,
  },
  {
    value: 'Huiszwaluw',
    name: 'Huiszwaluw',
  },
  {
    value: OTHER_SPECIE_OPTION_VALUE,
    name: OTHER_SPECIE_OPTION_VALUE,
  },
]

export const PHYSICAL_INSPECTION_SPECIE_SPEC_OPTIONS: SelectOption[] = [
  {
    value: 'Huismus',
    name: 'Huismus',
  },
  {
    value: 'Koolmees',
    name: 'Koolmees',
  },
  {
    value: 'Pimpelmees',
    name: 'Pimpelmees',
  },
  {
    value: 'Mees spec.',
    name: 'Mees spec.',
  },
  {
    value: 'Gierzwaluw',
    name: 'Gierzwaluw',
  },
  {
    value: 'Spreeuw',
    name: 'Spreeuw',
  },
  {
    value: 'Onbekend',
    name: 'Onbekend',
  },
  {
    value: OTHER_SPECIE_OPTION_VALUE,
    name: OTHER_SPECIE_OPTION_VALUE,
  },
]

export const PHYSICAL_INSPECTION_BOX_TYPE_OPTIONS: SelectOption[] = [
  {
    name: 'Nestkast',
    value: 'Nestkast',
  },
  {
    name: 'Vleermuizenkast',
    value: 'Vleermuizenkast',
  },
]

export const PHYSICAL_INSPECTION_BAT_BOX_TYPE_OPTIONS: SelectOption[] = [
  {
    name: 'Zomerkast',
    value: 'Zomerkast',
  },
  {
    name: 'Kraamkast',
    value: 'Kraamkast',
  },
]

export const TRAIL_FOUND_OPTION_VALUE = 'Ja'
export const TRAIL_NOT_FOUND_OPTION_VALUE = 'Nee'
export const IS_TRAIL_FOUND_OPTIONS: SelectOption[] = [
  {
    value: TRAIL_FOUND_OPTION_VALUE,
    name: TRAIL_FOUND_OPTION_VALUE,
  },
  {
    value: TRAIL_NOT_FOUND_OPTION_VALUE,
    name: TRAIL_NOT_FOUND_OPTION_VALUE,
  },
]

export const ANIMAL_PRESENT_OPTION_VALUE = 'Ja'
export const ANIMAL_NOT_PRESENT_OPTION_VALUE = 'Nee'
export const ANIMAL_PRESENT_OPTIONS: SelectOption[] = [
  {
    value: ANIMAL_PRESENT_OPTION_VALUE,
    name: ANIMAL_PRESENT_OPTION_VALUE,
  },
  {
    value: ANIMAL_NOT_PRESENT_OPTION_VALUE,
    name: ANIMAL_NOT_PRESENT_OPTION_VALUE,
  },
]

export const HEIGHT_OPTIONS: SelectOption[] = [
  {
    value: '0-2',
    name: '0-2',
  },
  {
    value: '2-4',
    name: '2-4',
  },
  {
    value: '4-6',
    name: '4-6',
  },
  {
    value: '6-8',
    name: '6-8',
  },
  {
    value: '8+',
    name: '8+',
  },
]

// QuickScan specific options
export const QUICKSCAN_SPECIE_OPTIONS: SelectOption[] = [
  { value: 'Vleermuis', name: 'Vleermuis' },
  { value: 'Vogels', name: 'Vogels' },
  { value: 'ZoogdierenOverig', name: 'ZoogdierenOverig' },
  { value: 'Amfibieën', name: 'Amfibieën' },
  { value: 'Vissen', name: 'Vissen' },
  { value: 'Reptielen', name: 'Reptielen' },
  { value: 'Insecten', name: 'Insecten' },
  { value: 'Planten', name: 'Planten' },
  { value: OTHER_SPECIE_OPTION_VALUE, name: OTHER_SPECIE_OPTION_VALUE },
]

export const QUICKSCAN_SPECIE_CATEGORY_OPTIONS: SelectOption[] = [
  { value: 'Gebouwbewonende vleermuizen', name: 'Gebouwbewonende vleermuizen' },
  { value: 'Boombewonende vleermuizen', name: 'Boombewonende vleermuizen' },
  { value: 'Alle vleermuizen', name: 'Alle vleermuizen' },
  { value: 'Uilen', name: 'Uilen' },
  { value: 'Roofvogels', name: 'Roofvogels' },
  { value: 'Zangvogels', name: 'Zangvogels' },
  { value: 'Watervogels', name: 'Watervogels' },
  { value: 'Kleine marterachtigen', name: 'Kleine marterachtigen' },
  { value: 'Overig', name: 'Overig' },
]

export const QUICKSCAN_INCLUDE_EXCLUDE_OPTIONS: SelectOption[] = [
  { value: 'Includeren', name: 'Includeren' },
  { value: 'Uitsluiten', name: 'Uitsluiten' },
]
